import { render } from "./CartFooterEmpty.vue?vue&type=template&id=3487207d&scoped=true"
import script from "./CartFooterEmpty.vue?vue&type=script&lang=js"
export * from "./CartFooterEmpty.vue?vue&type=script&lang=js"

import "./CartFooterEmpty.vue?vue&type=style&index=0&id=3487207d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3487207d"]])

export default __exports__